import { html, nothing, render } from "lit-html";
import { hasEnoughDeals } from "../../state/deals-flag";
import { data } from "@escapio/shared/state/payload";
import { translate } from "@escapio/shared/l10n/translate";
import { onChangeCurrency } from "@escapio/portal/state/travelData";

class DealsLink extends HTMLElement {
	connectedCallback() {
		this.render();
		onChangeCurrency(() => this.render());
	}

	render() {
		if (!hasEnoughDeals()) {
			render(nothing, this);
			this.classList.add("deals-link--empty");
			return;
		}
		this.classList.remove("deals-link--empty");

		const template = html`<a
			class=${this.additionalClasses}
			href=${data.uris.deals}
			><span class="fa fa-tags"></span
			><span class="menu-item__label"
				>${translate("header_deals_title")}</span
			></a
		>`;

		render(template, this, { host: this });
	}

	get additionalClasses() {
		return this.getAttribute("additional-classes") || "";
	}
}

customElements.define("esc-deals-link", DealsLink);
